export default [
    {
        path: '/term-signatures',
        name: 'term-signatures',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Assinatura de Termos',
            icon: 'mdi-signature-freehand',
            breadcrumbs: [
                { text: 'Lista de assinaturas', disabled: true }
            ]
        }
    }
]